let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4WuEN")).then(() => parcelRequire('8z5Fd'));